<template>
  <router-view></router-view>
</template>

<style lang="scss">
// 3rd party plugins css
@import "~bootstrap-vue/dist/bootstrap-vue.css";
@import "~perfect-scrollbar/css/perfect-scrollbar.css";
@import "~socicon/css/socicon.css";
@import "~animate.css";
@import "~@fortawesome/fontawesome-free/css/all.css";
@import "~line-awesome/dist/line-awesome/css/line-awesome.css";
@import "assets/plugins/flaticon/flaticon.css";
@import "assets/plugins/flaticon2/flaticon.css";
@import "assets/plugins/keenthemes-icons/font/ki.css";

// Main demo style scss
@import "assets/sass/style.vue";
</style>

<script>
import { OVERRIDE_LAYOUT_CONFIG } from "@/core/services/store/config.module";

export default {
  name: "MetronicVue",
  mounted() {
    this.$store.dispatch(OVERRIDE_LAYOUT_CONFIG);

    this.sendIframeHeight();

    this.setupHeightObserver();
  },
  methods: {
    sendIframeHeight() {
      if (!window.parent) return;

      const height =
        document.documentElement.scrollHeight || document.body.scrollHeight;

      window.parent.postMessage(
        { iframeHeight: height },
        'https://digiskillhub.id/'
      );

    },
    setupHeightObserver() {
      const observer = new MutationObserver(() => {
        this.sendIframeHeight();
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true,
      });

      this._heightObserver = observer;
    },
  },
  beforeDestroy() {
    if (this._heightObserver) {
      this._heightObserver.disconnect();
    }
  },
};
</script>
